import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ActivityIndicator } from 'react-native';
import { View } from '@dbk/ui-react-utils';
import { createContainer } from '@dbk-legacy/muster/react';
import ScrollableLayout from '../../../components/common/scrollable-layout';
import Text, { Large, H3 } from '@dbk/ui-text';
import styles from './pdf-statement.styles';
import { PALETTE } from '../../../constants';
import { List, ListItem } from '@dbk/ui-list';
import { PDF } from '@dbk/ui-icons';

class PdfStatement extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      loadingRow: null,
    };
  }

  componentDidMount() {

  }

  componentWillUnmount() {
    this.props.setTitle(null);
  }

  handleClick(e) {
    e.preventDefault();
  }

  renderMonthItem(row, portfolioId, rowID) {
    const { docRefNo, bpId, docPdfSize, txnRef } = row;
    let pdfTitle = '';
    switch (this.props.pagefrom) {
      case 'monthly':
        pdfTitle = portfolioId;
        break;
      case 'currentlyMonthly':
        pdfTitle = portfolioId;
        break;
      case 'advice':
        pdfTitle = txnRef;
        break;
      case 'correspondence':
        pdfTitle = txnRef;
        break;
      case 'daily':
        pdfTitle = portfolioId;
        break;
    }
    return (
      <div className="row">
        <View
          onPress={
            this.state.loadingRow == null
              ? this.handlePress.bind(this, bpId, docRefNo, rowID)
              : this.handleClick.bind(this)
          }
        >
          <div className="column large-9 medium-9 small-9 customVerticalHeight">
            <Large secondary>{pdfTitle}</Large>
          </div>
          <div className="column large-3 medium-3 small-3 customLogoDisplay">
            {this.state.loadingRow === rowID ? (
              <ActivityIndicator
                animating
                color={PALETTE.primaryText}
                size="large"
              />
            ) : (
                <View
                  style={
                    this.state.loadingRow == null
                      ? styles.logo
                      : styles.logoDisable
                  }
                >
                  <PDF
                    height={35}
                    width={35}
                    color={PALETTE.secondaryActive}
                  />
                </View>
              )}
          </div>
        </View>
      </div>
    );
  }

  handlePress(accId, did, rowID) {
    const docId = did;
    const accountId = accId;
    const outputType = 'portfolio';
    this.setState({ loadingRow: rowID });
    let callback = () => {
      this.setState({
        loadingRow: null,
      });
    }
    this.props
      .getStatementPdf({ accountId, docId, outputType }, callback)
  }

  closePdf() {
    this.setState({ loadingRow: null });
  }

  getPdfContentStyle() {
    const zIndex = this.state.loadingRow !== null ? 3 : 5;
    return {
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      zIndex: zIndex,
    };
  }

  render() {
    const portfolioId =
      this.props.monthly.portfolioId || this.props.dailyPdf.portfolioId;
    let pdfList = '';
    switch (this.props.pagefrom) {
      case 'monthly' || 'currentlyMonthly':
        pdfList = this.props.monthly.getMonthStatementList;
        break;
      case 'currentlyMonthly':
        pdfList = this.props.monthly.getMonthStatementList;
        break;
      case 'advice':
        pdfList = this.props.advices.selectedAdviceLists;
        break;
      case 'correspondence':
        pdfList = this.props.dailyPdf.dailyStatementsList;
        break;
      case 'daily':
        pdfList = this.props.dailyPdf.dailyStatementsList;
        break;
    }
    const {
      i18n: { messages },
      app: { global: { deviceInfo } },
    } = this.props;

    return (
      <ScrollableLayout
        testID="Reports-view"
        body={
          <div>
            {deviceInfo.isTablet &&
              <div>
                <H3 secondary >
                  {messages['app.report.items']}
                </H3>
              </div>
            }
            {pdfList ? (
              <div className="margin-top-20">
                <List fullWidth className="listFullHeight">
                  {pdfList.map((row, index) => (
                    <ListItem >
                      {this.renderMonthItem(row, portfolioId, index)}
                    </ListItem>
                  ))}
                </List>
              </div>
            ) : (
                <div>
                  <ActivityIndicator
                    animating
                    color={PALETTE.appBackground}
                    size="large"
                  />
                </div>
              )}
          </div>
        }
      />
    );
  }
}

PdfStatement.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object.isRequired,
  }),
};

export default createContainer({
  $queries: {
    monthly: {
      startDate: true,
      endDate: true,
      getMonthStatementList: true,
      pdf: true,
      portfolioId: true,
      selectedItems: true,
      selectedMonth: true,
      selectedYear: true,
      setEmpty: { $set: 'pdf' },
    },
    i18n: {
      messages: true,
    },
    getStatementPdf: {
      $call: 'monthly.getPdf',
    },
    setTitle: {
      $set: 'ui.customtitle',
    },
    app: {
      global: {
        deviceInfo: {
          isTablet: true,
          width: true,
          height: true,
        },
      },
    },
    advices: {
      selectedAdviceLists: true,
    },
    dailyPdf: {
      dailyStatementsList: true,
      pdf: true,
      portfolioId: true,
      selectedItems: true,
      setEmpty: { $set: 'pdf' },
    },
    platform: {
      directDownload: true,
    },
  },
})(PdfStatement);